import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useGetClaimTypesQuery } from "AppQuries/claim/claim-type";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ImageUploder from "Components/UI/ImageUploder";
import MultiImageUploader from "Components/UI/MultiImageUploader";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const isStatusOption2 = [
  { label: "Pending", value: 0 },
  { label: "Approved", value: 1 },
  { label: "Rejected", value: 2 },
];

const ClaimForm = () => {
  const userData = useSelector(loggedInUser);
  const {
    control,
    getValues,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
  });

  console.log(employees);

  const employeeOptions = Array.isArray(employees)
    ? employees
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.employeeCode,
          label: `${o.uniqueId}-${o.fullName}`,
          value: o.employeeCode.toString(),
        }))
    : [];

  const { data: claimTypes } = useGetClaimTypesQuery({
    companyCode: watch("companyCode"),
  });

  const claimTypeOptions = Array.isArray(claimTypes)
    ? claimTypes
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code.toString(),
        })) || []
    : [];

  const addAttachments = (value) => {
    const currentAttachments = watch(`claimAttachments`) || [];

    const newAttachment = value?.map((val) => ({
      slNo: (currentAttachments.length || 0) + 1,
      companyCode: userData?.companyCode,
      code: 0,
      employeeCode: watch(`employeeCode`).toString() || 0,
      attachment: val,
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate:  getCurrentFormattedDate(),
      isActive: true,
    }));

    const updatedAttachments = [...currentAttachments, ...newAttachment];

    // const updatedClaimData = watch("claimData").map((item, idx) =>
    //   idx === index ? { ...item, attachment: updatedAttachments } : item
    // );
    setValue(`claimAttachments`, updatedAttachments);
  };

  const removeAttachment = (attachmentIndex) => {
    const currentAttachments = watch(`claimAttachments`) || [];
    const updatedAttachments = currentAttachments.filter(
      (item, idx) => idx !== attachmentIndex
    );
    setValue(`claimAttachments`, updatedAttachments);
  };

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="employeeCode"
          type="commonSelect"
          placeholder="Select Employee"
          className={`form-control select ${
            errors.employeeCode ? "is-invalid" : ""
          }`}
          label="Employee"
          labelClassName="form-label"
          optionData={employeeOptions}
          required={true}
          requiredMessage="Employee is required"
          onChange={(e) => {
            setValue("employeeCode", e);
          }}
          defaultValue={watch("employeeCode")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="claimType"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.claimType ? "is-invalid" : ""
          }`}
          label="Claim Type"
          labelClassName="form-label"
          optionData={claimTypeOptions}
          required={true}
          requiredMessage="Employee is required"
          onChange={(e) => {
            setValue("claimType", e);
          }}
          defaultValue={watch("claimType")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="transactionId"
          type="text"
          placeholder="transaction Id "
          className={`form-control ${errors.transactionId ? "is-invalid" : ""}`}
          label="Transaction Id"
          labelClassName="form-label"
          required={true}
          requiredMessage="transactionId is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="description"
          type="text"
          placeholder="Description "
          className={`form-control ${errors.description ? "is-invalid" : ""}`}
          label="Description"
          labelClassName="form-label"
          required={true}
          requiredMessage="description is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="claimAmount"
          type="number"
          placeholder="Claim Amount "
          className={`form-control ${errors.claimAmount ? "is-invalid" : ""}`}
          label="Claim Amount"
          labelClassName="form-label"
          required={true}
          requiredMessage="Claim Amount is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="fromDate"
          type="date"
          placeholder="From Date"
          className={`form-control ${errors.fromDate ? "is-invalid" : ""}`}
          label="From Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="from date is required"
          defaultValue=""
          dateFormat="YYYY-MM-DD"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="toDate"
          type="date"
          placeholder="To "
          className={`form-control ${errors.toDate ? "is-invalid" : ""}`}
          label="To Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="to date is required"
          defaultValue=""
          dateFormat="YYYY-MM-DD"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="remarks"
          type="text"
          placeholder="Remarks"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          label="Remarks"
          labelClassName="form-label"
          required={true}
          requiredMessage="Remarks is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isApproval"
          type="commonSelect"
          placeholder="Select Is Approved"
          className={`form-control select ${
            errors.isApproval ? "is-invalid" : ""
          }`}
          label="Is Approved"
          labelClassName="form-label"
          optionData={isStatusOption2}
          required={true}
          requiredMessage="Is Approved is required"
          onChange={(selectedOption) => {
            setValue("isApproval", selectedOption);
            trigger("isApproval");
          }}
          defaultValue={watch("isApproval")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <MultiImageUploader
          base64Values={watch(`claimAttachments`)?.map((a) => a.attachment)}
          setBase64Values={(value) => {
            addAttachments(value);
          }}
          removeAttachment={(attachmentIndex) =>
            removeAttachment(attachmentIndex)
          }
          id={`claim-attachment-uploader`}
        />
        
      </div> */}
    </div>
  );
};

export default ClaimForm;
